import type { PresupuestoObra } from './tipos'
import { recalcularPresupuesto } from './tipos'

export const PRESUPUESTOS_INICIALES: PresupuestoObra[] = [
  recalcularPresupuesto({
    id: 'pre-2026-001',
    codigo: 'PRE-2026-001',
    nombre: 'Presupuesto Canalización y Alumbrado Industrial Bodega Central',
    cliente: 'MEGA DISTRIBUCIONES SAS',
    ubicacion: 'Zona Industrial Girón, Santander',
    proyecto_id: null,
    estado: 'borrador',
    aiu: {
      porcentaje_admin: 10,
      porcentaje_imprevistos: 2,
      porcentaje_utilidad: 5,
      porcentaje_iva_utilidad: 19,
    },
    activo: true,
    versiones: [
      {
        version: 1,
        fecha: '2026-10-25T10:00:00Z',
        motivo: 'Versión inicial de cotización de ingeniería',
        total: 28450000,
        capitulos: [],
        aiu: {
          porcentaje_admin: 10,
          porcentaje_imprevistos: 2,
          porcentaje_utilidad: 5,
          porcentaje_iva_utilidad: 19,
        },
      },
    ],
    capitulos: [
      {
        id: 'cap-1',
        orden: 1,
        nombre: 'Capítulo 1: Canalizaciones y Tubería Conduit',
        subtotal_capitulo: 0,
        items: [
          {
            id: 'item-101',
            apu_id: 'apu-can-01',
            codigo: 'APU-CAN-01',
            nombre: 'SUMINISTRO E INSTALACIÓN DE TUBERÍA EMT 3/4" INCLUYE ACCESORIOS DE FIJACIÓN Y SOPORTERÍA',
            unidad: 'ML',
            cantidad: 350,
            costo_directo_unitario: 44146,
            precio_unitario: 50137,
            subtotal: 0,
          },
          {
            id: 'item-102',
            apu_id: 'apu-spt-01',
            codigo: 'APU-SPT-01',
            nombre: 'SUMINISTRO E INSTALACIÓN DE VARILLA CU-CU 5/8 X 2.40 M INCLUYE TUBERÍA Y CAJA DE INSPECCIÓN',
            unidad: 'UND',
            cantidad: 4,
            costo_directo_unitario: 569830,
            precio_unitario: 647000,
            subtotal: 0,
          },
        ],
      },
      {
        id: 'cap-2',
        orden: 2,
        nombre: 'Capítulo 2: Red Eléctrica e Iluminación LED',
        subtotal_capitulo: 0,
        items: [
          {
            id: 'item-201',
            apu_id: 'apu-con-01',
            codigo: 'APU-CON-01',
            nombre: 'SUMINISTRO E INSTALACIÓN DE CABLE DE COBRE 2/0 AWG DESNUDO',
            unidad: 'ML',
            cantidad: 180,
            costo_directo_unitario: 78728,
            precio_unitario: 89400,
            subtotal: 0,
          },
          {
            id: 'item-202',
            apu_id: 'apu-ilu-01',
            codigo: 'APU-ILU-01',
            nombre: 'SALIDA PARA ILUMINACIÓN EN TUBERÍA EMT 1/2" PARA LÁMPARA HERMÉTICA LED 2X25W',
            unidad: 'UND',
            cantidad: 24,
            costo_directo_unitario: 275000,
            precio_unitario: 312500,
            subtotal: 0,
          },
        ],
      },
    ],
    created_at: '2026-10-25T10:00:00Z',
    updated_at: '2026-10-25T10:00:00Z',
  }),
]

